import { ComponentPropsWithRef, FC } from 'react';
import { CustomContentProps, SnackbarContent } from 'notistack';

type Props = ComponentPropsWithRef<typeof SnackbarContent> & CustomContentProps;

export const LoadingAnnouncement: FC<Props> = ({ message, ref }) => (
  <SnackbarContent
    ref={ref}
    role="alert"
    aria-atomic
    style={{
      padding: 0,
      border: 0,
      clipPath: 'rect(0 0 0 0)',
    }}
  >
    {message}
  </SnackbarContent>
);
